<div class="game-period-filters">
	<mtg-dropdown
		*ngIf="!team.sport.isStreetball()"
		[formControl]="periodControl"
		variant="button"
		label="Период"
		[errorVisible]="false"
	>
		<mtg-dropdown-item
			*ngFor="let period of periods"
			[value]="period"
		>{{ period }} период</mtg-dropdown-item>
		<mtg-dropdown-item
			*ngFor="let p of overtimePeriods"
			[value]="p"
		>{{ p - game.basketballGameConfig.periodsCount }} овертайм</mtg-dropdown-item>
	</mtg-dropdown>
	<mtg-dropdown
		[formControl]="positionControl"
		label="Позиция"
		variant="button"
		[errorVisible]="false"
	>
		<mtg-dropdown-item
			*ngFor="let value of positions"
			[value]="value"
		>{{ value | localization: positionLocalization }}</mtg-dropdown-item>
	</mtg-dropdown>
	<div class="search">
		<mtg-text-field
			size="sm"
			placeholder="Искать игрока..."
			[formControl]="query"
			trailingIcon="icons-search"
		></mtg-text-field>
	</div>
</div>

<mtg-table>
	<mtg-table-header-row mtgSticky="top" [top]="headerHeight">
		<mtg-table-identity-col>
			<div class="team" mtgFitToParent>
				<div class="logo">
					<a [routerLink]="getTeamRoute(team.id)">
						<img [src]="team.logo.path" *ngIf="team.logo.path" [alt]="team.name"/>
						<div [class]="team.getEmptyLogoClass()" *ngIf="!team.logo.path"></div>
					</a>
				</div>
				<div class="name">
					<a [routerLink]="getTeamRoute(team.id)">
						<span>{{ team.name }}</span>
					</a>
				</div>
			</div>
		</mtg-table-identity-col>
		<mtg-table-col>Очки</mtg-table-col>
		<mtg-table-col-group title="1 очко" *ngIf="game.team.sport.isStreetball()">
			<mtg-table-col>Поп.</mtg-table-col>
			<mtg-table-col><span class="text-muted">Брос.</span></mtg-table-col>
			<mtg-table-col>%</mtg-table-col>
		</mtg-table-col-group>
		<mtg-table-col-group title="2 очка">
			<mtg-table-col>Поп.</mtg-table-col>
			<mtg-table-col><span class="text-muted">Брос.</span></mtg-table-col>
			<mtg-table-col>%</mtg-table-col>
		</mtg-table-col-group>
		<mtg-table-col-group title="3 очка" *ngIf="game.team.sport.isClassicBasketball()">
			<mtg-table-col>Поп.</mtg-table-col>
			<mtg-table-col><span class="text-muted">Брос.</span></mtg-table-col>
			<mtg-table-col>%</mtg-table-col>
		</mtg-table-col-group>
		<mtg-table-col-group title="штрафной">
			<mtg-table-col>Поп.</mtg-table-col>
			<mtg-table-col><span class="text-muted">Брос.</span></mtg-table-col>
			<mtg-table-col>%</mtg-table-col>
		</mtg-table-col-group>
		<ng-container *ngIf="!isLight">
			<mtg-table-col-group title="Подбор">
				<mtg-table-col>Напад.</mtg-table-col>
				<mtg-table-col>Защ.</mtg-table-col>
				<mtg-table-col>Всего</mtg-table-col>
			</mtg-table-col-group>
			<mtg-table-col>Передачи</mtg-table-col>
			<mtg-table-col>Блоки</mtg-table-col>
			<mtg-table-col>Перехваты</mtg-table-col>
			<mtg-table-col>Потери</mtg-table-col>
		</ng-container>
		<mtg-table-col>Фолы</mtg-table-col>
		<mtg-table-col>Мин.</mtg-table-col>
		<mtg-table-col>+-</mtg-table-col>
	</mtg-table-header-row>
	<mtg-table-row>
		<mtg-table-identity-col>
			<div class="total-title">
				<mtg-svg-icon icon="icons-basketball"></mtg-svg-icon>
				Всего
			</div>
		</mtg-table-identity-col>
		<mtg-table-col>
			{{ getTotal('points') }}
		</mtg-table-col>
		<mtg-table-col-group *ngIf="game.team.sport.isStreetball()">
			<mtg-table-col>{{ getTotal('onePointsMade') }}</mtg-table-col>
			<mtg-table-col><span class="text-muted">{{ getTotal('onePointAttempts') }}</span></mtg-table-col>
			<mtg-table-col>{{ getPercent(getTotal('onePointsMade'), getTotal('onePointAttempts')) }}%</mtg-table-col>
		</mtg-table-col-group>
		<mtg-table-col-group>
			<mtg-table-col>{{ getTotal('twoPointsMade') }}</mtg-table-col>
			<mtg-table-col><span class="text-muted">{{ getTotal('twoPointAttempts') }}</span></mtg-table-col>
			<mtg-table-col>{{ getPercent(getTotal('twoPointsMade'), getTotal('twoPointAttempts')) }}%</mtg-table-col>
		</mtg-table-col-group>
		<mtg-table-col-group *ngIf="game.team.sport.isClassicBasketball()">
			<mtg-table-col>{{ getTotal('threePointsMade') }}</mtg-table-col>
			<mtg-table-col><span class="text-muted">{{ getTotal('threePointAttempts') }}</span></mtg-table-col>
			<mtg-table-col>{{ getPercent(getTotal('threePointsMade'), getTotal('threePointAttempts')) }}%</mtg-table-col>
		</mtg-table-col-group>
		<mtg-table-col-group>
			<mtg-table-col>{{ getTotal('freeThrowsMade') }}</mtg-table-col>
			<mtg-table-col><span class="text-muted">{{ getTotal('freeThrowAttempts') }}</span></mtg-table-col>
			<mtg-table-col>{{ getPercent(getTotal('freeThrowsMade'), getTotal('freeThrowAttempts')) }}%</mtg-table-col>
		</mtg-table-col-group>
		<ng-container *ngIf="!isLight">
			<mtg-table-col-group>
				<mtg-table-col>{{ getTotal('offensiveRebounds') }}</mtg-table-col>
				<mtg-table-col>{{ getTotal('defensiveRebounds') }}</mtg-table-col>
				<mtg-table-col>{{ getTotal('offensiveRebounds') + getTotal('defensiveRebounds') }}</mtg-table-col>
			</mtg-table-col-group>
			<mtg-table-col>{{ getTotal('assists') }}</mtg-table-col>
			<mtg-table-col>{{ getTotal('blocks') }}</mtg-table-col>
			<mtg-table-col>{{ getTotal('steals') }}</mtg-table-col>
			<mtg-table-col>{{ getTotal('turnovers') }}</mtg-table-col>
		</ng-container>
		<mtg-table-col>{{ getTotal('totalFouls') }}</mtg-table-col>
		<mtg-table-col></mtg-table-col>
		<mtg-table-col>{{ game.team.id === team.id ? game.teamScore - game.competitorTeamScore : game.competitorTeamScore - game.teamScore }}</mtg-table-col>
	</mtg-table-row>
	<mtg-table-row *ngFor="let user of filteredUsers; trackBy: identify">
		<mtg-table-identity-col>
			<div class="number">{{ user.gameUserNumber || '–' }}</div>
			<div class="photo">
				<a [routerLink]="getUserProfileRoute(user)">
					<ng-container *ngIf="!user.tournamentTeamUser.id">
						<img [src]="user.teamUser.user.photo.path"
								 *ngIf="user.teamUser.user.photo.path"
								 class="circle-image"/>
						<div class="empty-photo" *ngIf="!user.teamUser.user.photo.path">{{ user.teamUser.user.initials }}</div>
					</ng-container>
					<ng-container *ngIf="user.tournamentTeamUser.id">
						<img [src]="user.tournamentTeamUser.leaguePlayer.photo.path"
								 *ngIf="user.tournamentTeamUser.leaguePlayer.photo.path"
								 class="circle-image"/>
						<div class="empty-photo" *ngIf="!user.tournamentTeamUser.leaguePlayer.photo.path">
							{{ user.tournamentTeamUser.leaguePlayer.initials }}
						</div>
					</ng-container>
				</a>
			</div>
			<div class="info">
				<a [routerLink]="getUserProfileRoute(user)">
					<ng-container *ngIf="user.tournamentTeamUser.id">
						<div class="name">{{ user.tournamentTeamUser.leaguePlayer.shortName }}</div>
					</ng-container>
					<ng-container *ngIf="!user.tournamentTeamUser.id">
						<div class="name">{{ user.teamUser.user.shortName }}</div>
					</ng-container>
					<div class="text-muted">{{ user.teamUser.user.basketballProfile.position | localization: positionLocalization }}</div>
				</a>
			</div>
		</mtg-table-identity-col>
		<mtg-table-col>
			{{ getUserStatistic(user.id, 'points') }}
		</mtg-table-col>
		<mtg-table-col-group *ngIf="game.team.sport.isStreetball()">
			<mtg-table-col>{{ getUserStatistic(user.id, 'onePointsMade') }}</mtg-table-col>
			<mtg-table-col><span class="text-muted">{{ getUserStatistic(user.id, 'onePointAttempts') }}</span></mtg-table-col>
			<mtg-table-col>{{ getPercent(getUserStatistic(user.id, 'onePointsMade'), getUserStatistic(user.id, 'onePointAttempts')) }}%</mtg-table-col>
		</mtg-table-col-group>
		<mtg-table-col-group>
			<mtg-table-col>{{ getUserStatistic(user.id, 'twoPointsMade') }}</mtg-table-col>
			<mtg-table-col><span class="text-muted">{{ getUserStatistic(user.id, 'twoPointAttempts') }}</span></mtg-table-col>
			<mtg-table-col>{{ getPercent(getUserStatistic(user.id, 'twoPointsMade'), getUserStatistic(user.id, 'twoPointAttempts')) }}%</mtg-table-col>
		</mtg-table-col-group>
		<mtg-table-col-group *ngIf="game.team.sport.isClassicBasketball()">
			<mtg-table-col>{{ getUserStatistic(user.id, 'threePointsMade') }}</mtg-table-col>
			<mtg-table-col><span class="text-muted">{{ getUserStatistic(user.id, 'threePointAttempts') }}</span></mtg-table-col>
			<mtg-table-col>{{ getPercent(getUserStatistic(user.id, 'threePointsMade'), getUserStatistic(user.id, 'threePointAttempts')) }}%</mtg-table-col>
		</mtg-table-col-group>
		<mtg-table-col-group>
			<mtg-table-col>{{ getUserStatistic(user.id, 'freeThrowsMade') }}</mtg-table-col>
			<mtg-table-col><span class="text-muted">{{ getUserStatistic(user.id, 'freeThrowAttempts') }}</span></mtg-table-col>
			<mtg-table-col>{{ getPercent(getUserStatistic(user.id, 'freeThrowsMade'), getUserStatistic(user.id, 'freeThrowAttempts')) }}%</mtg-table-col>
		</mtg-table-col-group>
		<ng-container *ngIf="!isLight">
			<mtg-table-col-group>
				<mtg-table-col>{{ getUserStatistic(user.id, 'offensiveRebounds') }}</mtg-table-col>
				<mtg-table-col>{{ getUserStatistic(user.id, 'defensiveRebounds') }}</mtg-table-col>
				<mtg-table-col>{{ getUserStatistic(user.id, 'offensiveRebounds') + getUserStatistic(user.id, 'defensiveRebounds') }}</mtg-table-col>
			</mtg-table-col-group>
			<mtg-table-col>{{ getUserStatistic(user.id, 'assists') }}</mtg-table-col>
			<mtg-table-col>{{ getUserStatistic(user.id, 'blocks') }}</mtg-table-col>
			<mtg-table-col>{{ getUserStatistic(user.id, 'steals') }}</mtg-table-col>
			<mtg-table-col>{{ getUserStatistic(user.id, 'turnovers') }}</mtg-table-col>
		</ng-container>
		<mtg-table-col>{{ getUserStatistic(user.id, 'totalFouls') }}</mtg-table-col>
		<mtg-table-col>{{ userMinutes[user.id] || 0 }}</mtg-table-col>
		<mtg-table-col>{{ userEfficiency[user.id] || 0 }}</mtg-table-col>
	</mtg-table-row>
</mtg-table>
